import React from 'react';

const NextSession = ({ data }) => {
  if (!data) return null;

  const { date, dayName, sessionType, description, isToday, isTomorrow } = data;

  const getSessionColor = (type) => {
    const t = type.toLowerCase();
    if (t.includes('rest')) return 'blue-400';
    if (t.includes('long')) return 'orange-400';
    if (t.includes('quality') || t.includes('interval') || t.includes('tempo')) return 'yellow-400';
    return 'green-400'; // Easy/Recovery
  };
  
  const color = getSessionColor(sessionType);
  const borderColor = `border-${color}`;
  const textColor = `text-${color}`;

  // Helper to highlight key terms in description
  const formatDescription = (desc) => {
    if (!desc) return "Rest and recover.";
    return desc; // For now. Later we can add regex to bold pace/distance.
  };

  return (
    <div className={`bg-gray-800 rounded-xl p-6 border border-gray-700 relative overflow-hidden transition-all hover:border-gray-600`}>
       {/* Date header */}
       <div className="flex justify-between items-start mb-4">
           <div>
               <p className="text-gray-400 text-xs uppercase tracking-wider">
                  {isToday ? "Today's Session" : isTomorrow ? "Tomorrow's Session" : "Next Session"}
               </p>
               <h3 className="text-xl font-bold text-white mt-1">
                   {dayName}, <span className="text-gray-400 font-normal">{date}</span>
               </h3>
           </div>
           {/* Icon or visual */}
           <div className={`p-2 rounded-lg bg-gray-700/50 ${textColor}`}>
               {sessionType.includes('Rest') ? '🛌' : '🏃'}
           </div>
       </div>
       
       {/* Session Details */}
       <div className={`p-4 rounded-lg bg-gray-900/50 border-l-4 ${borderColor}`}>
           <p className={`font-semibold text-lg ${textColor} mb-1`}>
               {sessionType}
           </p>
           <p className="text-gray-300 leading-relaxed">
               {formatDescription(description)}
           </p>
       </div>
       
       {/* Footer / Context */}
       <div className="mt-4 flex gap-2">
           <span className="text-xs text-gray-500 bg-gray-900 px-2 py-1 rounded">
               Status: {isToday || isTomorrow ? "Planned" : "Upcoming"}
           </span>
       </div>
    </div>
  );
};

export default NextSession;
